var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden-sm-and-up bg"},[_c('div',{staticClass:"mobile_callme_wrap"},[_c('p',[_vm._v(" Copyright ©2020 鑫宇宸创造 . All Rights Reserved . 浙ICP备15031491号-1浙公网安备 33010802005636号 ")])]),_c('div',{staticClass:"navigate_wrap"})])
}]

export { render, staticRenderFns }